<div class="dashboard-container">
  <h1>{{ 'nav.dashboard' | translate }}</h1>
</div>
